import { useMemo } from 'react';
import { DTOLocation } from 'src/apis/dto/DTOLocation';
import IcStatusAfternoonFill from 'src/assets/images/icStatusAfternoonFill.svg';
import IcStatusEveningFill from 'src/assets/images/icStatusEveningFill.svg';
import IcStatusMorningFill from 'src/assets/images/icStatusMorningFill.svg';
import IcStatusNightFill from 'src/assets/images/icStatusNightFill.svg';
import useNow from 'src/hooks/useNow';
interface Props {
  timeZoneId?: DTOLocation['timeZoneId'];
  className?: string;
}
const PeerTimeIcon = ({
  timeZoneId = 'UTC',
  className
}: Props) => {
  const now = useNow();
  const hour = Number(new Intl.DateTimeFormat(undefined, {
    timeZone: timeZoneId,
    hour: 'numeric',
    hour12: false
  }).format(new Date(now))) ?? new Date(now).getHours();

  /** @see {https://git.dev.hpcnt.com/hyperconnect/azar-android/blob/c5bbe8f8b6022d591622d5281b43da0e10fedcf4/app/src/main/java/com/azarlive/android/presentation/common/ClockTextView.java#L125-L130} */
  const Icon = useMemo(() => {
    if (hour < 6) return IcStatusNightFill;else if (hour < 12) return IcStatusMorningFill;else if (hour < 18) return IcStatusAfternoonFill;else return IcStatusEveningFill;
  }, [hour]);
  return <Icon className={className} data-sentry-element="Icon" data-sentry-component="PeerTimeIcon" data-sentry-source-file="index.tsx" />;
};
export default PeerTimeIcon;